import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { RoleRoute } from "@/components/RoleRoute";
import { Layout } from "@/components/Layout";
import { Toaster } from "@/components/ui/sonner";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Leads from "@/pages/Leads";
import Followups from "@/pages/Followups";
import Applications from "@/pages/Applications";
import Clients from "@/pages/Clients";
import Attendance from "@/pages/Attendance";
import Analytics from "@/pages/Analytics";
import Payslips from "@/pages/Payslips";
import Team from "@/pages/Team";
import Settings from "@/pages/Settings";
import Tools from "@/pages/Tools";
import Companies from "@/pages/Companies";
import ImportLeads from "@/pages/ImportLeads";
import ImportHistory from "@/pages/ImportHistory";
import BankNotes from "@/pages/BankNotes";
import Queries from "@/pages/Queries";
import CoordFiles from "@/pages/CoordFiles";

const queryClient = new QueryClient({
  defaultOptions: { queries: { refetchOnWindowFocus: false, retry: 1, staleTime: 30000 } },
});

const CLIENT_TEAM = ["Admin", "Manager", "Team Leader", "Coordinator", "Telecaller"];
const ANALYTICS_TEAM = ["Admin", "Manager", "Team Leader"];
const LEADS_TEAM = ["Admin", "Manager", "Team Leader", "Telecaller"];
const ALL_ROLES = ["Admin", "Manager", "Team Leader", "Coordinator", "Telecaller"];
const COORD_TEAM = ["Admin", "Manager", "Team Leader", "Coordinator"];

function App() {
  return (
    <div className="App">
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
                <Route index element={<Dashboard />} />
                <Route path="leads" element={<RoleRoute allow={LEADS_TEAM}><Leads /></RoleRoute>} />
                <Route path="followups" element={<Followups />} />
                <Route path="applications" element={<RoleRoute allow={ALL_ROLES}><Applications /></RoleRoute>} />
                <Route path="clients" element={<RoleRoute allow={CLIENT_TEAM}><Clients /></RoleRoute>} />
                <Route path="attendance" element={<Attendance />} />
                <Route path="analytics" element={<RoleRoute allow={ALL_ROLES}><Analytics /></RoleRoute>} />
                <Route path="tools" element={<Tools />} />
                <Route path="bank-notes" element={<BankNotes />} />
                <Route path="queries" element={<Queries />} />
                <Route path="coord-files" element={<RoleRoute allow={COORD_TEAM}><CoordFiles /></RoleRoute>} />
                <Route path="payslips" element={<Payslips />} />
                <Route path="team" element={<RoleRoute allow={ANALYTICS_TEAM}><Team /></RoleRoute>} />
                <Route path="companies" element={<RoleRoute allow={ANALYTICS_TEAM}><Companies /></RoleRoute>} />
                <Route path="import-leads" element={<RoleRoute allow={ANALYTICS_TEAM}><ImportLeads /></RoleRoute>} />
                <Route path="import-history" element={<RoleRoute allow={ANALYTICS_TEAM}><ImportHistory /></RoleRoute>} />
                <Route path="settings" element={<RoleRoute allow={["Admin"]}><Settings /></RoleRoute>} />
              </Route>
            </Routes>
          </BrowserRouter>
          <Toaster position="top-right" richColors />
        </AuthProvider>
      </QueryClientProvider>
    </div>
  );
}

export default App;
